import { render, staticRenderFns } from "./control.vue?vue&type=template&id=b3132d36&scoped=true"
import script from "./control.vue?vue&type=script&lang=js"
export * from "./control.vue?vue&type=script&lang=js"
import style0 from "./control.vue?vue&type=style&index=0&id=b3132d36&prod&lang=scss&scoped=true"
import style1 from "./control.vue?vue&type=style&index=1&id=b3132d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3132d36",
  null
  
)

export default component.exports